import { ExperimentGroup, UserExperiments } from "../../helpers/const";

type ExperimentGroups = Partial<
  Record<
    (typeof UserExperiments)[keyof typeof UserExperiments],
    (typeof ExperimentGroup)[keyof typeof ExperimentGroup]
  >
>;

interface UserExperimentsState {
  groups: ExperimentGroups;
}

const initialState: UserExperimentsState = {
  groups: {
    [UserExperiments.addSum]: ExperimentGroup.A,
  },
};

interface SetExperimentsGroupsAction {
  type: "SET_EXPERIMENTS_GROUPS";
  payload: ExperimentGroups;
}

interface ResetExperimentsGroupsAction {
  type: "RESET_EXPERIMENTS_GROUPS";
}

type UserExperimentsAction =
  | SetExperimentsGroupsAction
  | ResetExperimentsGroupsAction;

export const userExperimentsReducer = (
  state: UserExperimentsState = initialState,
  action: UserExperimentsAction
): UserExperimentsState => {
  switch (action.type) {
    case "SET_EXPERIMENTS_GROUPS": {
      return { ...state, groups: action.payload };
    }
    case "RESET_EXPERIMENTS_GROUPS": {
      const { groups } = initialState;
      return { ...state, groups };
    }
    default:
      return state;
  }
};
